window.InfiniteScroll = class InfiniteScrollProducts {
  constructor({
    gridSelector = "#product-grid",
    paginationSelector = ".pagination .next",
    offset = 300,
    loadMoreText = "Load More",
    callback = () => {}
  }) {
    this.grid = document.querySelector(gridSelector);
    this.button = document.querySelector(paginationSelector);
    this.isLoading = false;
    this.loadMoreText = loadMoreText;
    this.offset = offset;
    this.callback = callback;
    this.watch();
  }

watch() {
    window.addEventListener("scroll", () => {
        if (this.isLoading || !this.button || this.button.getAttribute("data-disabled") == 'true') return;

        const buttonRect = this.button.getBoundingClientRect();
        const isVisible = buttonRect.top < window.innerHeight && buttonRect.bottom > 0;

        if (isVisible) {
            this.loadMore();
        }
    });
}

  async loadMore() {
    this.isLoading = true;
    this.button.innerHTML = this.loadMoreText;
    // ✅ re-run your JS on newly added products
    await this.callback();
    this.isLoading = false;
    this.button.innerHTML = ''
  }
}